module.exports = __webpack_public_path__ + "5243c9c3404ba61f3ed0864d3a187540.jpg";